// import ('bootstrap')
import('../assets/js/main')
import Alpine from 'alpinejs'
import * as FilePond from 'filepond';
import 'filepond/dist/filepond.min.css';/**/
// import 'jquery-nice-select/js/jquery.nice-select';
import * as FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
window.FilePond = FilePond;
window.FilePondPluginImagePreview = FilePondPluginImagePreview;
window.FilePondPluginFileValidateSize = FilePondPluginFileValidateSize;
FilePond.registerPlugin(FilePondPluginFileValidateSize);
window.Alpine = Alpine
// $('select').niceSelect();
Alpine.start()
